import { Routes } from '@angular/router';
import { DatenschutzComponent } from './ui/datenschutz/datenschutz.component';
import { DisclaimerComponent } from './ui/disclaimer/disclaimer.component';
import { ErrorPageComponent } from './ui/error-page/error-page.component';
import { ImpressumComponent } from './ui/impressum/impressum.component';
import { RateLimitErrorComponent } from './ui/rate-limit-error/rate-limit-error.component';

export const INFO_ROUTES: Routes = [
  {
    path: 'info/impressum',
    component: ImpressumComponent,
  },
  {
    path: 'info/datenschutz',
    component: DatenschutzComponent,
  },
  {
    path: 'info/WartezeitHinweis',
    component: RateLimitErrorComponent,
  },
  {
    path: 'info/disclaimer',
    component: DisclaimerComponent,
  },
  {
    path: 'info/error-page',
    component: ErrorPageComponent,
  },
  {
    path: 'info/no-result-page',
    component: ErrorPageComponent,
  },
  {
    path: 'info/not-accepted',
    component: ErrorPageComponent,
  },
  {
    path: 'info/identity-error',
    component: ErrorPageComponent,
  },
  {
    path: 'info/last-identity-error',
    component: ErrorPageComponent,
  },
];
